export const tipsConso = [
  {
    message:
      "Ce graphique illustre la quantité d'énergie que vous avez prélevée ou injectée sur le réseau électrique au fil du temps. Il vous permet d'en visualiser l'évolution, exprimée en kilowattheures (kWh)."
  },
  {
    message:
      "Si vous disposez d'une production d'énergie locale, la quantité que vous réinjectez sur le réseau est représentée par des valeurs négatives sur votre graphique."
  },
  // {
  //   message:
  //     "La normalisation prend en compte la rigueur de la saison de chauffe pour comparer les besoins en chaleur de votre habitation, indépendamment du climat extérieur. Seules les consommations de chauffage (gaz, mazout...) sont concernées, à l'exception de l'eau chaude sanitaire."
  // },
  {
    message:
      "L'indicateur bleu situé au-dessus du graphique précise l'agrégation (années, mois, jours) que vous consultez actuellement. Vous pouvez changer d'agrégation en cliquant directement sur la barre du graphique que vous souhaitez détailler. Pour revenir à la vue précédente, il vous suffit d'utiliser le bouton \"Précédent\" (situé en haut à gauche du graphique)."
  },
  {
    message:
      "Pour afficher vos consommations par semaine, il vous suffit de cocher l'option \"Affichage par semaine\" (située en bas du graphique)."
  },
  {
    message:
      "Dans la vue quart-horaire (disponible si activée auprès de votre GRD), explorez votre journée en détail : zoomez avec la molette de la souris et faites glisser le graphique en maintenant le clic."
  },
  {
    message:
      "Grâce au bouton \"Ajouter un événement\" (situé en haut à droite du graphique), vous pouvez annoter votre graphique. Ajoutez des repères temporels pour vous remémorer les événements ayant influencé vos habitudes énergétiques."
  },
  {
    message:
      "Il est possible que certaines données n'aient pas pu être récupérées. Pour pallier ce manque, nous les estimons sur la base de votre consommation habituelle."
  },
  {
    message:
      "Pour respecter le RGPD, vos données de consommation (index et consommations) ne sont conservées que 3 ans maximum : les données plus anciennes sont automatiquement supprimées."
  }
];

export const tipsBenchmark = [
  {
    message:
      "Le graphique de comparaison est basé sur un Benchmark qui est une technique permettant, à partir d’un ou plusieurs indices de référence, d’observer, comparer, évaluer ou analyser les performances d’un produit, service ou autres. Dans notre cas, le benchmark énergétique va vous permettre d’évaluer votre consommation énergétique par rapport à d’autres consommateurs qui présentent de mêmes indices de référence. Ce afin que vous puissiez observer la consommation d’autres personnes et qui sait peut-être vous inciter à encore plus améliorer la vôtre."
  },
  {
    message:
      "La courbe bleue représente votre prélèvement, tandis que la courbe orange est un prélèvement type qui a été calculée sur base d’une moyenne. Cette courbe va vous permettre de vous comparer à la moyenne consommation d’autres ménages de même type que le vôtre."
  },
  {
    message:
      "La période sur votre graphique peut être affichée par heure, jour, mois ou année. Il est aussi possible d'afficher une période définie en sélectionnant directement la zone dans le graphique"
  }
];
